// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__2BYYQ","lg":"Button_lg__1I1nB","label":"Button_label__2AAHL","caret":"Button_caret__1NWOi","black":"Button_black__2zUj0"};